import { render, staticRenderFns } from "./jituangaikuo.vue?vue&type=template&id=ae5df9c4&scoped=true&"
import script from "./jituangaikuo.vue?vue&type=script&lang=js&"
export * from "./jituangaikuo.vue?vue&type=script&lang=js&"
import style0 from "./jituangaikuo.vue?vue&type=style&index=0&id=ae5df9c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5df9c4",
  null
  
)

export default component.exports